var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63739 5.75586C8.4319 5.75586 9.88628 4.48328 9.88628 2.91309C9.88628 1.3429 8.4319 0.0703125 6.63739 0.0703125C4.84289 0.0703125 3.38851 1.3429 3.38851 2.91309C3.38851 4.48328 4.84289 5.75586 6.63739 5.75586ZM8.91162 6.46656H8.48774C7.92426 6.69309 7.29732 6.82191 6.63739 6.82191C5.97746 6.82191 5.35307 6.69309 4.78705 6.46656H4.36317C2.47984 6.46656 0.951843 7.80355 0.951843 9.45147V10.3754C0.951843 10.9639 1.49755 11.4414 2.17018 11.4414H11.1046C11.7772 11.4414 12.3229 10.9639 12.3229 10.3754V9.45147C12.3229 7.80355 10.795 6.46656 8.91162 6.46656Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.003b2f49d15b27c3cce9d0ecdb55ded1.svg";
export { ForwardRef as ReactComponent };